export default __webpack_public_path__ + "static/media/12.0b69560b.png";